import Button from "@components/atoms/Button/index";
import { TenureOptionProps } from "./TenureOption.types";
import styles from "./TenureOption.module.scss";

export const TenureOption = ({
  value,
  isSelected,
  onClick,
}: TenureOptionProps) => (
  <Button
    onButtonClick={() => onClick(value)}
    className={`${styles.base} ${isSelected ? styles.active : styles.inactive}`}
    ariaLabel={`Select ${value} months tenure`}
  >
    {value}
  </Button>
);
